/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect } from 'react'

declare global {
  interface Window {
    fwSettings?: { widget_id: string }
    FreshworksWidget?: (...args: any[]) => void & { q?: any[] }
  }
}

export default function FreshworksWidgetLoader({ widgetId }: { widgetId: string }) {
  useEffect(() => {
    // 1) Ensure settings exist before loading the script
    window.fwSettings = { widget_id: widgetId }

    // 2) Stub the queue if the real widget isn't loaded yet
    if (typeof window.FreshworksWidget !== 'function') {
      const stub: any = function () {
        ;(stub.q = stub.q || []).push(arguments)
      }
      stub.q = []
      window.FreshworksWidget = stub
    }

    // 3) Inject the script only once
    const id = 'fw-widget'
    if (!document.getElementById(id)) {
      const s = document.createElement('script')
      s.id = id
      s.async = true
      s.defer = true
      s.type = 'text/javascript'
      s.src = `https://widget.freshworks.com/widgets/${widgetId}.js`
      document.head.appendChild(s)
    }

    // cleanup the injected divs
    return () => {
      document.getElementById(id)?.remove()
      document.getElementById('freshworks-container')?.remove()
    }
  }, [widgetId])

  return null
}
